import React, {useState} from 'react';
import {AnnouncementItems} from '../consts/types';
import {AnnouncementWelcomeDialog} from './AnnouncementWelcomeDialog';
import {AnnouncementDialog} from './AnnouncementDialog';
import {checkIsWelcome, getWelcomePage} from './utils';

interface AnnouncementProps {
    announcements: AnnouncementItems[];
    onMessageSeen: (announcementVersion: string, showNextTime: boolean) => Promise<void>;
    announcementVersion: string;
    defaultOpen?: boolean;
}

export const Announcement = (props: AnnouncementProps) => {
    const [curPageIndex, setCurPageIndex] = useState(0);
    const {announcements, onMessageSeen, announcementVersion, defaultOpen = true} = props;
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const welcomePage = getWelcomePage(announcements);

    const getShowMoreLinkHandlerByVersion = (): ((linkUrl: string) => void) => {
        switch (announcementVersion) {
            case 'mailboxV2':
                return () => {
                    setCurPageIndex(announcements.length - 1);
                };
            default:
                return linkUrl => window.open(linkUrl, '_blank');
        }
    };

    const onClose = () => {
        onMessageSeen(announcementVersion, false);
        setIsOpen(false);
    };

    if (!isOpen) return null;

    if (checkIsWelcome(announcements[curPageIndex])) {
        return (
            <AnnouncementWelcomeDialog
                welcomeAnnouncement={welcomePage}
                onClose={onClose}
                onForward={() => setCurPageIndex(curPageIndex + 1)}
                showMoreLinkHandler={getShowMoreLinkHandlerByVersion()}
            />
        );
    }
    return (
        <AnnouncementDialog
            curPageIndex={curPageIndex}
            setCurPageIndex={setCurPageIndex}
            announcement={announcements}
            onClose={onClose}
            showMoreLinkHandler={getShowMoreLinkHandlerByVersion()}
        />
    );
};
